// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const incineroar: PokeData = {
  "id": 727,
  "name": "incineroar",
  "height": 18,
  "weight": 830,
  "base_experience": 239,
  "types": [
    PokeType.FIRE,
    PokeType.DARK
  ],
  "api_moves": [
    "scratch",
    "double-kick",
    "thrash",
    "leer",
    "bite",
    "growl",
    "roar",
    "ember",
    "flamethrower",
    "lick",
    "fury-swipes",
    "scary-face",
    "outrage",
    "swagger",
    "cross-chop",
    "bulk-up",
    "flare-blitz",
    "fire-fang",
    "darkest-lariat",
    "throat-chop"
  ],
  "moves": [
    "scratch",
    "double-kick",
    "leer",
    "bite",
    "growl",
    "ember",
    "flamethrower",
    "lick",
    "scary-face",
    "outrage",
    "bulk-up",
    "flare-blitz",
    "fire-fang"
  ],
  "evolution_chain": {
    "id": 375,
    "item": null,
    "species": [
      {
        "name": "litten",
        "order": 725,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "torracat",
        "order": 726,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 725,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 17,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "incineroar",
        "order": 727,
        "types": [
          PokeType.FIRE,
          PokeType.DARK
        ],
        "evolves_from_species_id": 726,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 138,
    "speed": 90,
    "ability_power": 172
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
